import { black_color } from "styles/theme";

export const merchantStreamlineDetailsContainerStyle = {
    backgroundColor: black_color
}

export const merchantStreamlineDetailsSpacerStyle = {
    height: "50px"
}